/**
 * Enum for conversation entry categories
 */
export enum ConversationCategory {
  OBJECTION = 'Objection',
  HESITATION = 'Hesitation',
  FAQ = 'FAQ',
  NEW_INQUIRY = 'New Inquiry',
  OTHER = 'Other'
}

/**
 * Helper function to check if a category is an objection-type
 */
export const isObjectionCategory = (category: string): boolean => {
  return category === ConversationCategory.OBJECTION || 
         category === ConversationCategory.HESITATION;
};

/**
 * Helper function to get category color for UI
 */
export const getCategoryColor = (category: string): string => {
  switch (category) {
    case ConversationCategory.OBJECTION:
      return 'red';
    case ConversationCategory.HESITATION:
      return 'orange';
    case ConversationCategory.FAQ:
      return 'blue';
    case ConversationCategory.NEW_INQUIRY:
      return 'green';
    case ConversationCategory.OTHER:
    default:
      return 'gray';
  }
};

/**
 * Helper function to get category icon for UI
 */
export const getCategoryIcon = (category: string): string => {
  switch (category) {
    case ConversationCategory.OBJECTION:
      return '⚠️';
    case ConversationCategory.HESITATION:
      return '🤔';
    case ConversationCategory.FAQ:
      return '❓';
    case ConversationCategory.NEW_INQUIRY:
      return '💡';
    case ConversationCategory.OTHER:
    default:
      return '💬';
  }
};